export const FETCH_FORM_DATA = 'fulcrum/containers/Approval/SpecSection/FETCH_FORM_DATA'
export const FETCH_FORM_DATA_START = 'fulcrum/containers/Approval/SpecSection/FETCH_FORM_DATA_START'
export const FETCH_FORM_DATA_SUCCESS = 'fulcrum/containers/Approval/SpecSection/FETCH_FORM_DATA_SUCCESS'
export const FETCH_FORM_DATA_ERROR = 'fulcrum/containers/Approval/SpecSection/FETCH_FORM_DATA_ERROR'
